/* sucrase/dist/esm/index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.getVersion = getVersion;
    exports.transform = transform;
    exports.getFormattedTokens = getFormattedTokens;
    const tslib_1 = require("tslib");
    const CJSImportProcessor_1 = tslib_1.__importDefault(require("add4298d4c") /* ./CJSImportProcessor */);
    const computeSourceMap_1 = tslib_1.__importDefault(require("03a5a23920") /* ./computeSourceMap */);
    const HelperManager_1 = require("40e1a4d3af") /* ./HelperManager */;
    const identifyShadowedGlobals_1 = tslib_1.__importDefault(require("5f4ada3fc1") /* ./identifyShadowedGlobals */);
    const NameManager_1 = tslib_1.__importDefault(require("425f39b83e") /* ./NameManager */);
    const Options_1 = require("bb0c9c6022") /* ./Options */;
    const parser_1 = require("7a45c9fdec") /* ./parser */;
    const TokenProcessor_1 = tslib_1.__importDefault(require("1c7cc5e988") /* ./TokenProcessor */);
    const RootTransformer_1 = tslib_1.__importDefault(require("131f5202c7") /* ./transformers/RootTransformer */);
    const formatTokens_1 = tslib_1.__importDefault(require("2e6a9a5b28") /* ./util/formatTokens */);
    const getTSImportedNames_1 = tslib_1.__importDefault(require("4160f5108d") /* ./util/getTSImportedNames */);
    ;
    function getVersion() {
        /* istanbul ignore next */
        return "3.35.0";
    }
    function transform(code, options) {
        (0, Options_1.validateOptions)(options);
        try {
            const sucraseContext = getSucraseContext(code, options);
            const transformer = new RootTransformer_1.default(sucraseContext, options.transforms, Boolean(options.enableLegacyBabel5ModuleInterop), options);
            const transformerResult = transformer.transform();
            let result = { code: transformerResult.code };
            if (options.sourceMapOptions) {
                if (!options.filePath) {
                    throw new Error("filePath must be specified when generating a source map.");
                }
                result = {
                    ...result,
                    sourceMap: (0, computeSourceMap_1.default)(transformerResult, options.filePath, options.sourceMapOptions, code, sucraseContext.tokenProcessor.tokens),
                };
            }
            return result;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            if (options.filePath) {
                e.message = `Error transforming ${options.filePath}: ${e.message}`;
            }
            throw e;
        }
    }
    /**
     * Return a string representation of the sucrase tokens, mostly useful for
     * diagnostic purposes.
     */
    function getFormattedTokens(code, options) {
        const tokens = getSucraseContext(code, options).tokenProcessor.tokens;
        return (0, formatTokens_1.default)(code, tokens);
    }
    /**
     * Call into the parser/tokenizer and do some further preprocessing:
     * - Come up with a set of used names so that we can assign new names.
     * - Preprocess all import/export statements so we know which globals we are interested in.
     * - Compute situations where any of those globals are shadowed.
     *
     * In the future, some of these preprocessing steps can be skipped based on what actual work is
     * being done.
     */
    function getSucraseContext(code, options) {
        const isJSXEnabled = options.transforms.includes("jsx");
        const isTypeScriptEnabled = options.transforms.includes("typescript");
        const isFlowEnabled = options.transforms.includes("flow");
        const disableESTransforms = options.disableESTransforms === true;
        const file = (0, parser_1.parse)(code, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
        const tokens = file.tokens;
        const scopes = file.scopes;
        const nameManager = new NameManager_1.default(code, tokens);
        const helperManager = new HelperManager_1.HelperManager(nameManager);
        const tokenProcessor = new TokenProcessor_1.default(code, tokens, isFlowEnabled, disableESTransforms, helperManager);
        const enableLegacyTypeScriptModuleInterop = Boolean(options.enableLegacyTypeScriptModuleInterop);
        let importProcessor = null;
        if (options.transforms.includes("imports")) {
            importProcessor = new CJSImportProcessor_1.default(nameManager, tokenProcessor, enableLegacyTypeScriptModuleInterop, options, options.transforms.includes("typescript"), Boolean(options.keepUnusedImports), helperManager);
            importProcessor.preprocessTokens();
            // We need to mark shadowed globals after processing imports so we know that the globals are,
            // but before type-only import pruning, since that relies on shadowing information.
            (0, identifyShadowedGlobals_1.default)(tokenProcessor, scopes, importProcessor.getGlobalNames());
            if (options.transforms.includes("typescript") && !options.keepUnusedImports) {
                importProcessor.pruneTypeOnlyImports();
            }
        }
        else if (options.transforms.includes("typescript") && !options.keepUnusedImports) {
            // Shadowed global detection is needed for TS implicit elision of imported names.
            (0, identifyShadowedGlobals_1.default)(tokenProcessor, scopes, (0, getTSImportedNames_1.default)(tokenProcessor));
        }
        return { tokenProcessor, scopes, nameManager, importProcessor, helperManager };
    }
}
